module.exports = __webpack_public_path__ + "img/china.87d6c351.svg";